<template>
  <div>
    <div class="flex flex-wrap -m-1.5 xl:-m-2 2xl:-m-2.5">
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full 2xl:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('total_#_buildings_structures')"
          :count="total['total_#_buildings'] || total.all_buildings || 0"
          class="bg-indigo-50 text-indigo-800 cursor-pointer h-full"
          @click="
            $router.push(
              `/building-list/${role == 'ministry_admin' ? 'new' : 'exg'}`
            )
          "
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('new_buildings_structures')"
          :count="total.new_buildings || 0"
          :img="require('@/assets/img/icons/organization.svg')"
          class="bg-sky-50 text-sky-600 cursor-pointer h-full"
          @click="$router.push('/building-list/exg')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3">
        <StatisticCard
          :loading="loading"
          :title="$t('existing_buildings_structures')"
          :count="total.existing_buildings || 0"
          :img="require('@/assets/img/icons/flat.svg')"
          class="bg-blue-50 text-blue-600 cursor-pointer h-full"
          @click="$router.push('/building-list/exg')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3 2xl:w-1/4">
        <StatisticCard
          :loading="loading"
          :title="$t('sustainable_buildings')"
          :count="total.sustainable_buildings || 0"
          :img="require('@/assets/img/safebuilding.svg')"
          class="bg-emerald-50 text-emerald-600 cursor-pointer h-full"
          @click="$router.push('/statistica/building/1,2')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3 2xl:w-1/4">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_buildings')"
          :count="total.not_sustainable_buildings || 0"
          :img="require('@/assets/img/not_sustainable_buildings.svg')"
          class="bg-orange-50 text-amber-600 cursor-pointer h-full"
          @click="$router.push('/statistica/building/3')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3 2xl:w-1/4">
        <StatisticCard
          :loading="loading"
          :title="$t('not_sustainable_buildings4')"
          :count="total.not_sustainable_buildings4 || 0"
          :img="require('@/assets/img/buildingbreak.svg')"
          class="bg-rose-50 text-rose-600 cursor-pointer h-full"
          @click="$router.push('/statistica/building/4')"
        />
      </div>
      <div class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2 lg:w-1/3 2xl:w-1/4">
        <StatisticCard
          :loading="loading"
          :title="$t('users')"
          :count="total.users || 0"
          :img="require('@/assets/img/icons/invest_card.svg')"
          class="bg-violet-50 text-violet-600 cursor-pointer h-full"
          @click="$router.push('/users')"
        />
      </div>
      <div
        v-for="(item, i) in data"
        :key="i"
        class="p-1.5 xl:p-2 2xl:p-2.5 w-full md:w-1/2"
      >
        <OrgCard :data="item" />
      </div>
    </div>
    <pre>{{ data }}</pre>
  </div>
</template>
<script>
import StatisticCard from "./Card.vue";
import OrgCard from "./OrgCard.vue";

export default {
  name: "RegionStatistic",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StatisticCard,
    OrgCard,
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    total() {
      return this.data.reduce((totals, org) => {
        return {
          users: (totals.users || 0) + (org.users || 0),
          all_buildings: (totals.all_buildings || 0) + (org.all_buildings || 0),
          new_buildings: (totals.new_buildings || 0) + (org.new_buildings || 0),
          existing_buildings:
            (totals.existing_buildings || 0) + (org.existing_buildings || 0),
          sustainable_buildings:
            (totals.sustainable_buildings || 0) +
            (org.sustainable_buildings || 0),
          not_sustainable_buildings:
            (totals.not_sustainable_buildings || 0) +
            (org.not_sustainable_buildings || 0),
          not_sustainable_buildings4:
            (totals.not_sustainable_buildings4 || 0) +
            (org.not_sustainable_buildings4 || 0),
        };
      }, {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
